import { CharField, ImageField, NumberField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { GroupOfResearches } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function GroupOfResearchForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<GroupOfResearches>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.name}
        onChange={(value) => {
          setFieldValue("name", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "name") : undefined}
        errorMessage={getIn(errors, "name")}
        required
      />

      <ImageField
        label="Immagine"
        layout="horizontal"
        value={values.image}
        onChange={(value) => {
          setFieldValue("image", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "image") : undefined}
        errorMessage={getIn(errors, "image")}
        required
      />

      <CharField
        label="Università"
        layout="horizontal"
        value={values.university}
        onChange={(value) => {
          setFieldValue("university", value)
        }}
      />

      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.description}
        onChange={(value) => {
          setFieldValue("description", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "description") : undefined}
        errorMessage={getIn(errors, "description")}
        required
      />
      <NumberField
        label="Ordine"
        layout="horizontal"
        value={values.order}
        onChange={(value) => {
          setFieldValue("order", value)
        }}
      />
    </Col>
  )
}
